export const LegacyCRMIframeID = 'legacy-crm-iframe'

export const ReactToLegacyCrmPostMessageAction = {
  ReactToIframeMessageOpenPage: 'reactToIframeMessageOpenPage',
  ReactToIframeMessageOpenPanel: 'reactToIframeMessageOpenPanel',
  ReactToIframeMessageOpenModal: 'reactToIframeMessageOpenModal',
  ReactToIframeMessageOpenDeleteRecModal: 'reactToIframeMessageOpenDeleteRecModal',
  ReactToIframeMessageTriggerClickEvent: 'reactToIframeMessageTriggerClickEvent',
}

export const PanelLegacyLink = {
  AddContact: {
    extras: 'cid=',
    extrasTitle: '',
    parentPanel: 0,
    panelType: 'c_overview',
  },
  AddNote: {
    extras: 'view_all=n',
    extrasTitle: '',
    parentPanel: 1,
    panelType: 'cal_tabs',
  },
  AddProspectAppraisal: {
    extras: 'cma_property_id=',
    extrasTitle: '',
    parentPanel: 1,
    panelType: 'add_prospect',
  },
  LogEnquiry: {
    extras: '',
    extrasTitle: 'Log Enquiry',
    parentPanel: 1,
    panelType: 'add_enq',
  },
  AddTask: {
    extras: 'task_id=na&newdate=',
    extrasTitle: '',
    parentPanel: 1,
    panelType: 'cal_tabs',
  },
  AddAppointment: {
    extras: 'view_all=m',
    extrasTitle: '',
    parentPanel: 1,
    panelType: 'cal_tabs_sec',
  },
  ApplySchedule: {
    extras: 'add=1',
    extrasTitle: 'Apply Activity Schedule',
    parentPanel: 1,
    panelType: 'plan_tabs',
  },
  NewReferral: {
    extras: '',
    extrasTitle: 'New Referral',
    parentPanel: 1,
    panelType: 'new_referral',
  },
  PortalLogs: {
    extras: 'status_filter=20',
    extrasTitle: '',
    parentPanel: 1,
    panelType: 'portal_logs',
  },
  // User Menu
  MyProfile: (mem_id: string) => ({
    extras: `mem_id=${mem_id}`,
    extrasTitle: '',
    parentPanel: 1,
    panelType: 'staff_tabs',
  }),
  ManageSMSCredits: {
    extras: '',
    extrasTitle: '',
    parentPanel: 1,
    panelType: 'sms_credits_balance',
  },
  PurchaseSMSCredits: {
    panel_type: 'dummy_not_needed_here',
    is_fm_tree: false,
    ex_vars: {
      force_post_url: 'payment/sms/request',
      force_get_url: 'payment/sms/request',
      w: 600,
      h: 720,
      force_del_act: '1',
      validate: '1',
      c: 'DEL_REC_loadjs',
    },
    ex_act: 'DEL_REC_afterjs',
  },
  EnewsletterSchedule: {
    extras: 'campaignType=enews',
    extrasTitle: '',
    parentPanel: 1,
    panelType: 'campaigns',
  },
  Testimonials: {
    extras: '',
    extrasTitle: '',
    parentPanel: 1,
    panelType: 'testimonials',
  },
  ManageSubscription: {
    extras: 'status_filter=20',
    extrasTitle: '',
    parentPanel: 1,
    panelType: 'manage_subscription',
  },
  UniversalSearchId: 'unisearch-turbo-button',
  ReactTopBar: 'react-top-bar', // Just a reference to legacy CRM to close UniSearch when clicked topbar
}

export const ThirdPartyExternalLink = {
  ReapitAcademy: {
    url: 'https://agentbox-academy.myshopify.com/',
  },
}
